// elements/components/stack/x-stack-button.ts
import { webcomponent } from "@adornis/functional-lit/webcomponent.js";
import { html, nothing } from "lit";
import { acss } from "../../../directives/acss.js";
import { DesignSystem } from "../../theming/design.js";
var XStackButton = webcomponent(
  "x-stack-button",
  ({
    name,
    onClickCallback,
    previews
  }) => {
    const design = DesignSystem.currentTheme.getValue();
    const padding = "12px";
    const borderThickness = "3px";
    return html`
      <x-flex
        space="xxs"
        ${acss({
      boxShadow: "rgba(0, 0, 0, 0.1) 4px 4px 40px",
      borderRadius: "4px",
      padding,
      borderLeft: `${borderThickness} solid ${design.colors.accent}`,
      "&:hover": {
        cursor: "pointer",
        background: "#333",
        color: "#fff",
        userSelect: "none",
        borderLeft: `${borderThickness} solid transparent`
      }
    })}
        @click=${(e) => {
      e.stopPropagation();
      onClickCallback();
    }}
      >
        <x-flex horizontal crossaxis-center space="sm">
          <x-text>${name}</x-text>
        </x-flex>

        ${previews && previews.length ? html` <x-flex horizontal crossaxis-center space="sm" wrap> ${previews} </x-flex> ` : nothing}
      </x-flex>
    `;
  },
  { shadowRoot: true }
);
export {
  XStackButton
};
